import { useEffect } from "react";
import { message } from "antd";

import { useRevokeBusinessOwnership as useRevokeBusinessOwnershipApi } from "../../../../../hooks/api/claimBusiness";
import { getMessageInError } from "../../../../../hooks/fetch";


export const useRevokeBusinessOwnership = (id: string) => {
    const { fetch: revokeBusinessOwnership, response, error, loading } = useRevokeBusinessOwnershipApi(id)

    useEffect(() => {
        if (response?.data.success) {
            message.success('Business claimed successfully')
        }
    }, [response])

    useEffect(() => {
        if (error) {
            message.error(getMessageInError(error))
        }
    }, [error])

    return {
        revokeBusinessOwnership,
        response,
        error,
        loading,
    };
}
